import React, { Component } from "react";
import { Link } from "react-router-dom";
import { SideBar, NavBar, TitleAndDescription, Footer } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import PouchDB from "pouchdb";
import PouchdbFind from "pouchdb-find";
// import "./PedidoNovo.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import tipoPedidoModel from "../../models/tipoPedido";
import clienteModel from "../../models/cliente";
import condPagamentoModel from "../../models/condPagamento";
import formaPagamentoModel from "../../models/formaPagamento";
import transportadoraModel from "../../models/transportadora";
import sequenciaPedidoModel from "../../models/sequenciaPedido";
import saldoReservaModel from "../../models/saldoReserva"; //NÃO É UTILIZADO
import usuarioModel from "../../models/usuario";
import saldoOverModel from "../../models/saldoOver";
import pedidoModel from "../../models/pedido";
import produtoModel from "../../models/produto";
import agendaModel from "../../models/agenda";
import orcamentoModel from "../../models/orcamento";
import vendedorModel from "../../models/vendedor";
import AsyncSelect from "react-select/async";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from "reactstrap";
import descontoModel from "../../models/desconto";
import queryString from "query-string";
import axios from "axios";
import moment from "moment";
import empresaModel from "../../models/empresa";
require("dotenv").config();
const { formatarReal, formatarRealCarrinho } = require("../../utils");
const { formatarCasaDecimal } = require("../../utils");
PouchDB.plugin(PouchdbFind);

let VALIDAR_ESTOQUE = localStorage.getItem("validarEstoque");

if (VALIDAR_ESTOQUE === null) {
  VALIDAR_ESTOQUE = true;
} else {
  VALIDAR_ESTOQUE = VALIDAR_ESTOQUE === "true" ? true : false;
}

let PERMITIR_ALTERAR_CONDICAO_PAGAMENTO = localStorage.getItem(
  "permitirAlterarCondicaoPagamento"
);

if (PERMITIR_ALTERAR_CONDICAO_PAGAMENTO === null) {
  PERMITIR_ALTERAR_CONDICAO_PAGAMENTO = true;
} else {
  PERMITIR_ALTERAR_CONDICAO_PAGAMENTO =
    PERMITIR_ALTERAR_CONDICAO_PAGAMENTO === "true" ? true : false;
}

export default class PedidoNovo extends Component {
  constructor(props) {
    super(props);
    this.loadUsuario = this.loadUsuario.bind(this);
    this.calcularTotalPedido = this.calcularTotalPedido.bind(this);
    this.loadPedidoStorage = this.loadPedidoStorage.bind(this);
    this.loadSequenciaPedido = this.loadSequenciaPedido.bind(this);
    this.setTipoPedidoPadrao = this.setTipoPedidoPadrao.bind(this);
    this.load = this.load.bind(this);
    this.localizacao = this.localizacao.bind(this);
    this.getLocation = this.getLocation.bind(this);
    this.bloqueio = this.bloqueio.bind(this);
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.validarPedido = this.validarPedido.bind(this);
    this.cadastrarPedido = this.cadastrarPedido.bind(this);
    this.setarInfoSugerida = this.setarInfoSugerida.bind(this);
    this.gravarPedidoStorage = this.gravarPedidoStorage.bind(this);
    this.getDefaultPedido = this.getDefaultPedido.bind(this);
    this.transformDataComboBox = this.transformDataComboBox.bind(this);
    this.gravaSaldoReserva = this.gravaSaldoReserva.bind(this);
    this.buscaDadosCliente = this.buscaDadosCliente.bind(this);
    this.promiseOptions = this.promiseOptions.bind(this);
    this.abrirPaginaInfoPedido = this.abrirPaginaInfoPedido.bind(this);
    this.calcularValorDesconto = this.calcularValorDesconto.bind(this);
    this.abrirPaginaCarrinho = this.abrirPaginaCarrinho.bind(this);
    this.verificaLegendaCliente = this.verificaLegendaCliente.bind(this);
    this.promiseOptionsDesconto = this.promiseOptionsDesconto.bind(this);
    this.removeDesconto = this.removeDesconto.bind(this);
    this.gerarPedido = this.gerarPedido.bind(this);
    this.toggle = this.toggle.bind(this);
    this.abrirPaginaEditarContatos = this.abrirPaginaEditarContatos.bind(this);
    this.loadParametros = this.loadParametros.bind(this);
    this.atualizaSaldoOver = this.atualizaSaldoOver.bind(this);
    this.abrirPaginasEtapa = this.abrirPaginasEtapa.bind(this);
    this.gerarImpressao = this.gerarImpressao.bind(this);
    this.formatarAgendamentoImpressao =
      this.formatarAgendamentoImpressao.bind(this);
    this.verificaAutenticacao = this.verificaAutenticacao.bind(this);
    this.editarOrcamento = this.editarOrcamento.bind(this);

    this.state = {
      //actionPage: this.props.action,
      idPedido: null,
      actionPage: "CADASTRAR",
      tiposPedido: [],
      clientes: [],
      condicoesPagamento: [],
      formasPagamento: [],
      transportadoras: [],
      pedido: this.getDefaultPedido(),
      contatos: [],
      enderecos: [],
      totalPedido: 0,
      usuario: null,
      codigoPedido: "",
      localizacao: false,
      errors: {
        tipoPedido: false,
        cliente: false,
        condPagto: false,
        formaPagto: false,
        transportadora: false,
        contato: false,
        endereco: false,
      },
      db: null,
      exibirLegendaCliente: false,
      textoLegenda: "",
      limiteCreditoCliente: null,
      corLegenda: "",
      descontos: [],
      listaDivergencias: [],
      modalDivergencias: false,
      modal: false,
      idCliente: null,
      habilitarCampoCondicao: true,
      parametros: null,
      comissao: 0,
    };
  }

  async componentDidMount() {
    let idPedido = queryString.parse(this.props.location.search).id;
    this.verificaAutenticacao();
    let db = await new PouchDB(this.props.getBaseUrlBanco(), {
      auth: this.props.getUserBanco(),
      skipSetup: true,
    });

    let actionPage = this.state.actionPage;
    if (idPedido !== undefined) {
      actionPage = "EDITAR";
    }

    this.setState(
      {
        db: db,
        idPedido,
        actionPage,
      },
      async () => {
        await this.loadUsuario();
        await this.loadParametros();
        await this.load();
        await this.loadPedidoStorage();

        if (this.state.actionPage === "CADASTRAR") {
          await this.loadSequenciaPedido();
          await this.setTipoPedidoPadrao();
        }

        await this.calcularTotalPedido();
        await this.getLocation();

        if (this.state.actionPage === "CADASTRAR") {
          if (localStorage.getItem("pedido") === null) {
            this.props.history.push("/home");
            return false;
          }
        } else if (this.state.actionPage === "EDITAR") {
          if (localStorage.getItem("orcamento") === null) {
            this.props.history.push("/home");
            return false;
          }
        }
      }
    );
  }

  async localizacao() {
    let loc = false;
    await navigator.permissions
      .query({ name: "geolocation" })
      .then(function (result) {
        loc = result.state;
      });
    this.setState({ localizacao: true });
  }

  async getLocation() {
    if (navigator.geolocation) {
      await navigator.geolocation.getCurrentPosition(
        // Success function
        this.localizacao,
        // Error function
        this.bloqueio,
        // Options. See MDN for details.
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }

  async bloqueio() {
    this.setState({ localizacao: false });
  }

  async loadUsuario() {
    let usuario = await usuarioModel.find(this.state.db);
    this.setState({ usuario });
  }

  async loadParametros() {
    let query = {
      selector: {
        type: { $eq: "parametros" },
      },
      limit: 1,
    };

    let result = await this.state.db.find(query);
    let parametros = result.docs[0];

    this.setState({ parametros });
  }

  async calcularTotalPedido() {
    if (this.state.pedido.itens.length) {
      let totalPedido = 0;

      for (let item of this.state.pedido.itens) {
        let valor = item.produto.preco.precoUnitComImpostosFinal;

        if (this.state.parametros.tipoDesconto === "progressivo") {
          if (
            this.state.pedido.desconto !== null &&
            this.state.pedido.desconto.pDesc !== 0
          ) {
            valor = this.calcularValorDesconto(
              valor,
              this.state.pedido.desconto.pDesc
            );
          }
        } else {
          if (
            this.state.pedido.condPagto !== null &&
            this.state.pedido.condPagto.pDesc !== 0
          ) {
            valor = this.calcularValorDesconto(
              valor,
              this.state.pedido.condPagto.pDesc
            );
          }
        }

        valor = item.quantidade * valor;

        totalPedido += valor;
      }

      let comissao = 0;
      let pedido = this.state.pedido;

      for (let item of pedido.itens) {
        if (
          item.produto.comissao !== undefined &&
          item.produto.comissao !== 0
        ) {
          let valor = parseFloat(
            (
              (item.produto.comissao *
                (item.produto.preco.precoUnitComImpostosFinal *
                  item.quantidade)) /
              100
            ).toFixed(2)
          );
          comissao += valor;
        }
      }

      totalPedido = parseFloat(totalPedido.toFixed(2));
      this.setState({ totalPedido, comissao }, () => {
        // this.verificaLegendaCliente(this.state.pedido.cliente.idIntegracao);
      });
    }
  }

  async loadPedidoStorage() {
    let pedidoStorage = null;
    if (this.state.actionPage === "CADASTRAR") {
      pedidoStorage = localStorage.getItem("pedido");
    } else if (this.state.actionPage === "EDITAR") {
      pedidoStorage = localStorage.getItem("orcamento");
    }
    let lastPageStorage = localStorage.getItem("lastPage");

    if (pedidoStorage !== null) {
      pedidoStorage = JSON.parse(pedidoStorage);
      if (pedidoStorage.cliente !== null) {
        delete pedidoStorage.cliente.label;
      }
    }

    if (this.state.actionPage === "CADASTRAR") {
      if (pedidoStorage !== null) {
        if (
          lastPageStorage !== null &&
          (lastPageStorage === "adicionarItens" ||
            lastPageStorage === "pedidoInfo" ||
            lastPageStorage === "editarCliente")
        ) {
          for (let item of pedidoStorage.itens) {
            if (item.quantidade > 0) {
              let valorTotalItem = item.produto.preco.precoUnitComImpostosFinal;
              valorTotalItem = valorTotalItem * item.quantidade;
              item.valorTotalItem = valorTotalItem;
            }
          }
          this.setState({ pedido: pedidoStorage }, () => {
            if (pedidoStorage.cliente !== null) {
              this.handleChangeSelect(pedidoStorage.cliente, "cliente");
            } else {
              let clienteCorrigirStorage =
                localStorage.getItem("clienteCorrigir");

              if (clienteCorrigirStorage !== null) {
                clienteCorrigirStorage = JSON.parse(clienteCorrigirStorage);

                this.handleChangeSelect(
                  clienteCorrigirStorage,
                  "cliente",
                  true
                );
              }
            }
          });
        } else {
          localStorage.removeItem("pedido");
        }
      } else {
        let idAgenda = queryString.parse(this.props.location.search).agenda;
        let idCliente = queryString.parse(this.props.location.search).cliente;

        if (idAgenda !== undefined) {
          this.setState({
            pedido: { ...this.state.pedido, idAgenda: idAgenda },
          });
        }

        if (idCliente !== undefined) {
          this.handleChangeSelect({ _id: idCliente }, "cliente", true);
        }
      }
    }

    if (this.state.actionPage === "EDITAR") {
      const idPedido = this.state.idPedido;
      let pedidoBanco = await pedidoModel.findById2(this.state.db, idPedido);

      await this.setState({
        idPedido: pedidoBanco._id,
        revPedido: pedidoBanco._rev,
        codigoPedido: pedidoBanco.codigo,
        status: pedidoBanco.status,
        pedidoData: pedidoBanco.data,
      });

      if (pedidoStorage !== null) {
        if (
          (lastPageStorage !== null && lastPageStorage === "adicionarItens") ||
          lastPageStorage === "pedidoInfo"
        ) {
          this.setState({ pedido: pedidoStorage }, () => {
            this.handleChangeSelect(pedidoStorage.cliente, "cliente");
          });
          return false;
        }
      }

      let pedido = {};

      pedido.tipoPedido = this.state.tiposPedido.find(
        (i) => i.idIntegracao === pedidoBanco.tipoPedido.idIntegracao
      );

      pedido.tipoPedido = this.state.tiposPedido.find(
        (i) => i.idIntegracao === pedidoBanco.tipoPedido.idIntegracao
      );

      pedido.condPagto = this.state.condicoesPagamento.find(
        (i) => i.idIntegracao === pedidoBanco.condPagto.idIntegracao
      );

      pedido.formaPagto = this.state.formasPagamento.find(
        (i) => i.idIntegracao === pedidoBanco.formaPagto.idIntegracao
      );

      pedido.transportadora = this.state.transportadoras.find(
        (i) => i.idIntegracao === pedidoBanco.transportadora.idIntegracao
      );

      pedido.observacao = pedidoBanco.observacao;

      let cliente = await clienteModel.findById(
        this.state.db,
        pedidoBanco.cliente._id
      );
      cliente.value = cliente.descFormat;
      cliente.label = cliente.descFormat;
      // if (titulo) {
      //   cliente.label = (
      //     <span
      //       dangerouslySetInnerHTML={{
      //         __html: `<i class="fa fa-file" style="color: red"></i> ${cliente.descFormat}`,
      //       }}
      //     ></span>
      //   );
      // } else {
      //   cliente.label = cliente.descFormat;
      // }
      let contatos = cliente.contatos;
      contatos = this.transformDataComboBox(contatos);
      let enderecos = cliente.enderecos;
      enderecos = enderecos.map((endereco) => {
        endereco.value = endereco.endereco;
        endereco.label = `${endereco.endereco}, ${endereco.numero}`;
        return endereco;
      });

      pedido.cliente = cliente;

      let habilitarCampoCondicao = true;

      if (
        pedido.cliente.condPagto !== null &&
        pedido.cliente.condPagto !== undefined
      ) {
        if (!PERMITIR_ALTERAR_CONDICAO_PAGAMENTO) {
          habilitarCampoCondicao = false;
        }
      }

      if (pedidoBanco.contato === null) {
        pedido.contato = contatos.find(
          (i) => i.idIntegracao === pedidoBanco.contato.idIntegracao
        );
      } else {
        pedido.contato = pedidoBanco.contato;
        pedido.contato.value = pedido.contato.desc;
        pedido.contato.label = pedido.contato.desc;
      }

      if (pedidoBanco.enderecoEntrega === null) {
        pedido.endereco = enderecos.find(
          (i) => i.idIntegracao === pedidoBanco.enderecoEntrega.idIntegracao
        );
      } else {
        pedido.endereco = pedidoBanco.enderecoEntrega;
        pedido.endereco.value = pedido.endereco.endereco;
        pedido.endereco.label = `${pedido.endereco.endereco}, ${pedido.endereco.numero}`;
      }

      pedido.itens = [];
      pedido.expiracao = pedidoBanco.expiracao;

      for (let itemOrcamento of pedidoBanco.itens) {
        let produto = itemOrcamento.produto;

        let testeFelipe = await produtoModel.getGiro(
          this.state.db,
          produto._id
        );

        produto.giro = testeFelipe.giro;
        produto.imagemPrincipal = testeFelipe.imagemPrincipal;
        itemOrcamento = this.removeDesconto(itemOrcamento);
      }

      pedido.itens = pedidoBanco.itens;

      for (let item of pedido.itens) {
        if (item.quantidade > 0) {
          let valorTotalItem = item.produto.preco.precoUnitComImpostosFinal;
          valorTotalItem = valorTotalItem * item.quantidade;
          item.valorTotalItem = valorTotalItem;
        }
      }

      pedido.status = pedidoBanco.status;
      pedido.previsaoEntrega = new Date(pedidoBanco.previsaoEntrega);
      pedido.desconto = pedidoBanco.desconto;

      if (pedido.desconto !== null) {
        pedido.desconto.value = pedido.desconto.desc;
        pedido.desconto.label = pedido.desconto.desc;
      }

      let idAgenda = null;

      if (pedidoBanco.idAgenda !== undefined && pedidoBanco.idAgenda !== null) {
        idAgenda = pedidoBanco.idAgenda;
      }

      pedido.idAgenda = idAgenda;
      this.setState(
        { pedido: pedido, contatos, enderecos, habilitarCampoCondicao },
        () => {
          //localStorage.setItem("pedido", JSON.stringify(this.state.pedido));
        }
      );
    }
  }

  async loadSequenciaPedido() {
    let sequencia = await sequenciaPedidoModel.get(this.state.db);
    sequencia = `${this.state.usuario.codWeb}/${sequencia
      .toString()
      .padStart(4, 0)}`;
    this.setState({ codigoPedido: sequencia });
  }

  getDefaultPedido() {
    return {
      tipoPedido: null,
      cliente: null,
      condPagto: null,
      formaPagto: null,
      transportadora: null,
      itens: [],
      contato: null,
      endereco: {
        endereco: "",
        bairro: "",
        cidade: "",
        uf: "",
      },
      observacao: "",
      previsaoEntrega: new Date(),
      desconto: null,
      expiracao: null,
      status: "A",
      idAgenda: null,
      permitidoAlterarClientePedido: true,
    };
  }

  transformDataComboBox(lista) {
    lista = lista.map((item) => {
      item.value = item.desc;
      item.label = item.desc;
      return item;
    });
    return lista;
  }

  transformDataComboBoxCliente(lista) {
    lista = lista.map((item) => {
      item.value = item.descFormat;
      item.label = item.descFormat;
      // if (item.titulos)
      //   item.label = (
      //     <span
      //       dangerouslySetInnerHTML={{
      //         __html: `<i class="fa fa-file" style="color: red"></i> ${item.descFormat}`,
      //       }}
      //     ></span>
      //   );
      // else item.label = item.descFormat;
      return item;
    });
    return lista;
  }

  async load() {
    let tiposPedidoBusca = await tipoPedidoModel.findAll(this.state.db);
    tiposPedidoBusca = this.transformDataComboBox(tiposPedidoBusca);

    // let clientesBusca = await clienteModel.findAll(this.state.db);
    //clientesBusca = this.transformDataComboBox(clientesBusca);
    // clientesBusca = clientesBusca.sort(ordenarIdIntegracao);

    let condPagamentos = await condPagamentoModel.findAll(this.state.db);
    condPagamentos = this.transformDataComboBox(condPagamentos);

    let formaPagamentosBusca = await formaPagamentoModel.findAll(this.state.db);
    formaPagamentosBusca = this.transformDataComboBox(formaPagamentosBusca);

    let transportadorasBusca = await transportadoraModel.findAll(this.state.db);
    transportadorasBusca = this.transformDataComboBox(transportadorasBusca);

    this.setState({
      tiposPedido: tiposPedidoBusca,
      // clientes: clientesBusca,
      condicoesPagamento: condPagamentos,
      formasPagamento: formaPagamentosBusca,
      transportadoras: transportadorasBusca,
    });
  }

  setTipoPedidoPadrao() {
    let tipoPedidoPadrao = this.state.tiposPedido.find(
      (item) => item.padrao === true
    );

    if (tipoPedidoPadrao !== undefined) {
      let localPedido = this.state.pedido;
      localPedido.tipoPedido = tipoPedidoPadrao;
      this.setState({ pedido: localPedido });
    }
  }

  async handleChangeSelect(item, tipo, clienteSelecionadoNovo = false) {
    let pedidoLocal = this.state.pedido;
    let clienteCorrigir = Object.assign({}, item);

    if (tipo === "cliente") {
      item = await this.buscaDadosCliente(item._id);

      if (item === null) {
        this.notificar(
          "error",
          "Este cliente não esta mais na carteira do vendedor."
        );

        setTimeout(() => {
          this.props.history.push("/home");
        }, 2000);
        return false;
      }

      let titulos = await clienteModel.findTitulo(
        this.state.db,
        item.idIntegracao
      );

      item.value = item.descFormat;
      item.label = item.descFormat;

      if (titulos.length) {
        item.label = (
          <span
            dangerouslySetInnerHTML={{
              __html: `<i class="fa fa-file" style="color: red"></i> ${item.descFormat}`,
            }}
          ></span>
        );
      }

      let contatos = item.contatos;
      contatos = this.transformDataComboBox(contatos);
      let enderecos = item.enderecos;
      enderecos = enderecos.map((endereco) => {
        endereco.value = endereco.endereco;
        endereco.label = `${endereco.endereco}, ${endereco.numero}`;
        return endereco;
      });

      let clienteValido = true;

      for (let contato of contatos) {
        if (contato.status === "A") {
          // this.setState({ modal: true, idCliente: item._id });
          // clienteValido = false;
          // break;

          if (contato.email === "" || contato.fone === "") {
            this.setState({ modal: true, idCliente: item._id });
            clienteValido = false;
            break;
          }
        }
      }

      // clienteValido = false;

      if (!clienteValido) {
        localStorage.setItem(
          "clienteCorrigir",
          JSON.stringify(clienteCorrigir)
        );
        return false;
      } else {
        pedidoLocal.contato = contatos.find((cont) => cont.padrao === true);

        if (clienteSelecionadoNovo) {
          pedidoLocal.endereco = enderecos.find(
            (end) => end.principal === true
          );
        }

        pedidoLocal.cliente = item;
        pedidoLocal = this.setarInfoSugerida(pedidoLocal);
        let habilitarCampoCondicao = true;

        if (
          pedidoLocal.cliente.condPagto !== null &&
          pedidoLocal.cliente.condPagto !== undefined
        ) {
          if (!PERMITIR_ALTERAR_CONDICAO_PAGAMENTO) {
            habilitarCampoCondicao = false;
          }
        }

        this.setState(
          {
            contatos,
            enderecos,
            pedido: pedidoLocal,
            limiteCreditoCliente: item.limiteCredito,
            habilitarCampoCondicao,
          },
          () => {
            //localStorage.setItem("pedido", JSON.stringify(this.state.pedido));
            // this.verificaLegendaCliente(item.idIntegracao);
          }
        );
      }
    } else if (tipo === "condPagto" || tipo === "desconto") {
      this.setState({ pedido: { ...this.state.pedido, [tipo]: item } }, () => {
        this.calcularTotalPedido();
      });
    } else {
      this.setState({ pedido: { ...this.state.pedido, [tipo]: item } });
    }
  }

  verificaLegendaCliente(idIntegracaoCliente) {
    let alertaClientes = localStorage.getItem("legendaCliente");

    if (alertaClientes !== null) {
      alertaClientes = JSON.parse(alertaClientes);
      let clienteFind = alertaClientes.clientes.find(
        (i) => i === idIntegracaoCliente
      );

      if (clienteFind !== undefined) {
        this.setState({
          exibirLegendaCliente: true,
          textoLegenda:
            "Cliente possui títulos em atraso. Sujeito a aprovação do Depto. Financeiro da empresa",
          corLegenda: "#dc494a",
        });
      } else {
        let limiteCredito = this.state.limiteCreditoCliente;

        if (limiteCredito !== null) {
          if (this.state.totalPedido > limiteCredito) {
            this.setState({
              exibirLegendaCliente: true,
              textoLegenda:
                "Total do pedido acima do limite de crédito do cliente. Sujeito a aprovação do Depto. Financeiro da empresa.",
              corLegenda: "#F59C00",
            });
          } else {
            this.setState({
              exibirLegendaCliente: false,
              textoLegenda: "",
              corLegenda: "",
            });
          }
        }
      }
    }
  }

  handleChangeInput(e, tipo) {
    this.setState({ pedido: { ...this.state.pedido, [tipo]: e.target.value } });
  }

  validarPedido() {
    let errorsLocal = this.state.errors;
    let pedido = this.state.pedido;
    let camposObrigatorios = [
      "tipoPedido",
      "cliente",
      "condPagto",
      "formaPagto",
      "transportadora",
      "contato",
    ];

    let valido = true;

    for (let campo of camposObrigatorios) {
      if (pedido[campo] === null) {
        errorsLocal[campo] = true;
        valido = false;
      } else {
        errorsLocal[campo] = false;
      }
    }

    if (pedido.endereco.endereco === "") {
      errorsLocal.endereco = true;
      valido = false;
    } else {
      errorsLocal.endereco = false;
    }

    this.setState({ errors: errorsLocal });
    return valido;
  }

  async cadastrarPedido(typeDoc) {
    if (!this.validarPedido()) {
      this.notificar(
        "warning",
        "Favor preencher todos os campos corretamente!"
      );
      return false;
    }

    if (this.state.codigoPedido === "") {
      this.notificar("warning", "Aguarde carregar o id do pedido");
      return false;
    }

    if (this.state.pedido.itens.length === 0) {
      this.notificar("warning", "Adicione itens ao pedido");
      return false;
    }

    let pedido = this.state.pedido;

    let vendedorFind = await vendedorModel.buscarPorIdIntegracao(
      this.state.db,
      pedido.cliente.vendedor.idIntegracao
    );

    let empresaFind = await empresaModel.buscarPorIdIntegracao(
      this.state.db,
      vendedorFind.idEmpresa
    );

    let novoPedido = {
      _id: `${this.state.usuario.codWeb}-${new Date().getTime()}`,
      type: typeDoc,
      valorTotal: this.state.totalPedido,
      data: new Date(),
      codigo: this.state.codigoPedido,
      sinc: false,
      sincIntegracao: false,
      dtIntegracao: null,
      status: "A",
      empresa: {
        idIntegracao: vendedorFind.idEmpresa,
        razaoSocial: empresaFind.razaoSocial,
        cnpjCpf: empresaFind.cnpj,
        ie: empresaFind.ie,
      },
      usuario: {
        _id: this.state.usuario._id,
        desc: this.state.usuario.desc,
      },
      vendedor: {
        idIntegracao: vendedorFind.idIntegracao,
        _id: vendedorFind._id,
        desc: vendedorFind.desc,
        enviaCopiaPedido: false,
        email: vendedorFind.email,
        cel: vendedorFind.cel !== undefined ? vendedorFind.cel : "",
      },
      tipoPedido: {
        idIntegracao: pedido.tipoPedido.idIntegracao,
        desc: pedido.tipoPedido.desc,
      },
      cliente: {
        _id: pedido.cliente._id,
        idIntegracao: pedido.cliente.idIntegracao,
        cod: pedido.cliente.cod,
        desc: pedido.cliente.desc,
        cnpjCpf: pedido.cliente.cnpjCpf,
        fantasia: pedido.cliente.fantasia,
        descFormat: pedido.cliente.descFormat,
        obs: pedido.cliente.obs,
        cod: pedido.cliente.cod,
      },
      condPagto: {
        idIntegracao: pedido.condPagto.idIntegracao,
        desc: pedido.condPagto.desc,
        pDesc: pedido.condPagto.pDesc,
      },
      formaPagto: {
        idIntegracao: pedido.formaPagto.idIntegracao,
        desc: pedido.formaPagto.desc,
      },
      transportadora: {
        idIntegracao: pedido.transportadora.idIntegracao,
        desc: pedido.transportadora.desc,
      },
      contato: {
        idIntegracao: pedido.contato.idIntegracao,
        desc: pedido.contato.desc,
        fone: pedido.contato.fone,
        cel: pedido.contato.cel,
        email: pedido.contato.email,
      },
      enderecoEntrega: {
        idIntegracao: pedido.endereco.idIntegracao,
        endereco: pedido.endereco.endereco,
        numero: pedido.endereco.numero,
        complemento: pedido.endereco.complemento,
        bairro: pedido.endereco.bairro,
        cidade: pedido.endereco.cidade,
        estado: pedido.endereco.estado,
        cep: pedido.endereco.cep,
      },
      observacao: pedido.observacao,
      itens: pedido.itens,
      situacao: {
        desc: "Novo",
        cor: "preto",
      },
      previsaoEntrega: pedido.previsaoEntrega,
      desconto: pedido.desconto,
      idAgenda: pedido.idAgenda,
      sincOver: false,
      ordemCompra: pedido.ordemCompra,
    };

    if (pedido.endereco.idIntegracaoRandom !== undefined) {
      novoPedido.enderecoEntrega.idIntegracaoRandom =
        pedido.endereco.idIntegracaoRandom;
    }

    for (let itemPedido of novoPedido.itens) {
      delete itemPedido.produto.imagemPrincipal;
      delete itemPedido.sequencia;
      delete itemPedido.produto.giro;
      delete itemPedido.sequencia;
      delete itemPedido.quantidadeString;
      delete itemPedido.estoque;

      let pDesc = 0;

      if (this.state.parametros.tipoDesconto === "progressivo") {
        if (novoPedido.desconto !== null) {
          pDesc = novoPedido.desconto.pDesc;
        }
      } else {
        pDesc = novoPedido.condPagto.pDesc;
      }

      let precoUnitComImpostosFinal = this.calcularValorDesconto(
        itemPedido.produto.preco.precoUnitComImpostosFinal,
        pDesc
      );
      itemPedido.produto.preco.precoUnitComImpostosFinal = parseFloat(
        precoUnitComImpostosFinal.toFixed(2)
      );

      let precoTotalComImpostosFinal = parseFloat(
        (
          itemPedido.quantidade *
          itemPedido.produto.preco.precoUnitComImpostosFinal
        ).toFixed(2)
      );
      itemPedido.produto.preco.precoTotalComImpostosFinal =
        precoTotalComImpostosFinal;

      let itemPreco = itemPedido.produto.preco;
      itemPreco.precoTotalComImpostosFinal = formatarCasaDecimal(
        itemPreco.precoTotalComImpostosFinal
      );
      itemPreco.precoUnitComImpostosFinal = formatarCasaDecimal(
        itemPreco.precoUnitComImpostosFinal
      );
      itemPreco.precoTotalComImpostosFinal = formatarCasaDecimal(
        itemPreco.precoTotalComImpostosFinal
      );
      itemPreco.valorDesconto = formatarCasaDecimal(itemPreco.valorDesconto);
      itemPreco.valorAcrescimo = formatarCasaDecimal(itemPreco.valorAcrescimo);
      itemPedido.produto.preco = itemPreco;
    }

    if (this.state.parametros.tipoDesconto === "over" && typeDoc === "pedido") {
      await this.atualizaSaldoOver(vendedorFind, pedido.itens, novoPedido._id);
    }

    if (this.state.actionPage === "EDITAR") {
      novoPedido._id = this.state.idPedido;
      novoPedido._rev = this.state.revPedido;
      novoPedido.status = this.state.status;
      novoPedido.data = this.state.pedidoData;
      novoPedido.sinc = false;
    } else {
      let novoCodigo = await sequenciaPedidoModel.increment(this.state.db);

      this.setState(
        {
          pedido: this.getDefaultPedido(),
          totalPedido: 0,
          codigoPedido: `${this.state.usuario.codWeb}/${novoCodigo
            .toString()
            .padStart(4, 0)}`,
          exibirLegendaCliente: false,
        },
        () => {
          this.setTipoPedidoPadrao();
        }
      );
    }

    if (novoPedido.desconto !== undefined && novoPedido.desconto !== null) {
      novoPedido.desconto = {
        idIntegracao: novoPedido.desconto.idIntegracao,
        desc: novoPedido.desconto.desc,
        pDesc: novoPedido.desconto.pDesc,
      };
    }

    await pedidoModel.salvarPedido(this.state.db, novoPedido);
    localStorage.removeItem("pedido");
    this.notificar("success", "Pedido gravado com sucesso");

    if (this.state.actionPage === "CADASTRAR") {
      let idAgendaFinalizarPedido = localStorage.getItem(
        "idAgendaFinalizarPedido"
      );

      if (idAgendaFinalizarPedido !== null) {
        await agendaModel.finalizarAgendaPedido(
          this.state.db,
          novoPedido.idAgenda,
          novoPedido._id
        );
        localStorage.removeItem("idAgendaFinalizarPedido");
      }
    }

    if (this.state.actionPage === "EDITAR") {
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      // setTimeout(() => {
      //   this.props.history.push(`/${typeDoc}-detalhe?id=${novoPedido._id}`);
      // }, 1500);

      await axios
        .post(`${this.props.getBaseUrlApi()}/meta-usuario/atualizar`, {
          idUsuario: this.state.usuario._id,
          idVendedor: novoPedido.vendedor._id,
        })
        .then(async (response) => {})
        .catch((error) => {
          console.log(error);
          if (error.response !== undefined) {
            // this.notificar("warning", error.response.data.erro);
          }
        });

      let pedidoImpressao = this.formatarAgendamentoImpressao(novoPedido);
      this.gerarImpressao(pedidoImpressao);

      setTimeout(() => {
        let url = "";
        if (typeDoc === "pedido") {
          url = "/pedidos";
        } else if (typeDoc === "orcamento") {
          url = "/orcamentos";
        }
        this.props.history.push(url);
      }, 1500);

      // let idAgendaFinalizar = novoPedido.idAgenda;
      // if (idAgendaFinalizar !== undefined && idAgendaFinalizar !== null) {
      //   setTimeout(() => {
      //     window.location.href = "/pedidos/novo";
      //   }, 1500);
      // }
    }
  }
  async editarOrcamento(actionType) {
    if (!this.validarPedido()) {
      this.notificar(
        "warning",
        "Favor preencher todos os campos corretamente!"
      );
      return false;
    }

    let pedido = this.state.pedido;

    if (pedido.itens.length === 0) {
      this.notificar("warning", "Adicione itens ao pedido");
      return false;
    }

    let orcamentoBanco = await pedidoModel.findById2(
      this.state.db,
      this.state.idPedido
    );

    if (orcamentoBanco === null) {
      return this.props.history.push("/home");
    }

    if (!orcamentoBanco.expiracao.permitidoAlteracao) {
      // PEDIDO EXPIRADO OU INATIVO
      return this.props.history.push("/home");
    }

    orcamentoBanco = {
      ...orcamentoBanco,
      valorTotal: this.state.totalPedido,
      tipoPedido: {
        idIntegracao: pedido.tipoPedido.idIntegracao,
        desc: pedido.tipoPedido.desc,
      },
      condPagto: {
        idIntegracao: pedido.condPagto.idIntegracao,
        desc: pedido.condPagto.desc,
        pDesc: pedido.condPagto.pDesc,
      },
      formaPagto: {
        idIntegracao: pedido.formaPagto.idIntegracao,
        desc: pedido.formaPagto.desc,
      },
      transportadora: {
        idIntegracao: pedido.transportadora.idIntegracao,
        desc: pedido.transportadora.desc,
      },
      contato: {
        idIntegracao: pedido.contato.idIntegracao,
        desc: pedido.contato.desc,
        fone: pedido.contato.fone,
        cel: pedido.contato.cel,
        email: pedido.contato.email,
      },
      enderecoEntrega: {
        idIntegracao: pedido.endereco.idIntegracao,
        endereco: pedido.endereco.endereco,
        numero: pedido.endereco.numero,
        complemento: pedido.endereco.complemento,
        bairro: pedido.endereco.bairro,
        cidade: pedido.endereco.cidade,
        estado: pedido.endereco.estado,
        cep: pedido.endereco.cep,
      },
      observacao: pedido.observacao,
      itens: pedido.itens,
      previsaoEntrega: pedido.previsaoEntrega,
      ordemCompra: pedido.ordemCompra,
    };

    if (pedido.endereco.idIntegracaoRandom !== undefined) {
      orcamentoBanco.enderecoEntrega.idIntegracaoRandom =
        pedido.endereco.idIntegracaoRandom;
    }

    for (let itemPedido of orcamentoBanco.itens) {
      delete itemPedido.produto.imagemPrincipal;
      delete itemPedido.sequencia;
      delete itemPedido.produto.giro;
      delete itemPedido.sequencia;
      delete itemPedido.quantidadeString;
      delete itemPedido.estoque;

      let pDesc = 0;

      if (this.state.parametros.tipoDesconto === "progressivo") {
        if (orcamentoBanco.desconto !== null) {
          pDesc = orcamentoBanco.desconto.pDesc;
        }
      } else {
        pDesc = orcamentoBanco.condPagto.pDesc;
      }

      let precoUnitComImpostosFinal = this.calcularValorDesconto(
        itemPedido.produto.preco.precoUnitComImpostosFinal,
        pDesc
      );
      itemPedido.produto.preco.precoUnitComImpostosFinal = parseFloat(
        precoUnitComImpostosFinal.toFixed(2)
      );

      let precoTotalComImpostosFinal = parseFloat(
        (
          itemPedido.quantidade *
          itemPedido.produto.preco.precoUnitComImpostosFinal
        ).toFixed(2)
      );
      itemPedido.produto.preco.precoTotalComImpostosFinal =
        precoTotalComImpostosFinal;

      let itemPreco = itemPedido.produto.preco;
      itemPreco.precoTotalComImpostosFinal = formatarCasaDecimal(
        itemPreco.precoTotalComImpostosFinal
      );
      itemPreco.precoUnitComImpostosFinal = formatarCasaDecimal(
        itemPreco.precoUnitComImpostosFinal
      );
      itemPreco.precoTotalComImpostosFinal = formatarCasaDecimal(
        itemPreco.precoTotalComImpostosFinal
      );
      itemPreco.valorDesconto = formatarCasaDecimal(itemPreco.valorDesconto);
      itemPreco.valorAcrescimo = formatarCasaDecimal(itemPreco.valorAcrescimo);
      itemPedido.produto.preco = itemPreco;
    }

    await pedidoModel.salvarPedido(this.state.db, orcamentoBanco);
    if (actionType === "editarOrcamento") {
      localStorage.removeItem("orcamento");
      this.notificar("success", "Orçamento editado com sucesso");
      setTimeout(() => {
        return this.props.history.push("/orcamentos");
      }, 1500);
    }else if(actionType === 'gerarPedido'){
      return true;
    }
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  setarInfoSugerida(pedido) {
    let itensSugerir = [
      { item: "formaPagto", lista: this.state.formasPagamento },
      { item: "condPagto", lista: this.state.condicoesPagamento },
      { item: "transportadora", lista: this.state.transportadoras },
    ];

    for (let itemSugerir of itensSugerir) {
      if (
        pedido.cliente[itemSugerir.item] !== undefined &&
        pedido.cliente[itemSugerir.item] !== null
      ) {
        let itemBusca = itemSugerir.lista.find(
          (item) =>
            item.idIntegracao === pedido.cliente[itemSugerir.item].idIntegracao
        );
        if (itemBusca !== undefined) {
          if (pedido[itemSugerir.item] === null) {
            pedido[itemSugerir.item] = itemBusca;
          }
        }
      }
    }

    return pedido;
  }

  gravarPedidoStorage() {
    if (this.state.pedido.cliente === null) {
      this.notificar("warning", "Escolha o cliente");
      return false;
    }
    localStorage.setItem("pedido", JSON.stringify(this.state.pedido));
    this.props.history.push(
      `/adicionar/itens?cliente=${this.state.pedido.cliente.idIntegracao}`
    );
  }

  async gravaSaldoReserva(pedido) {
    let listaItensAgrupados = [];
    for (let itemPedido of pedido.itens) {
      let itemFind = listaItensAgrupados.find(
        (i) => i._id === itemPedido.produto._id
      );
      if (itemFind === undefined) {
        listaItensAgrupados.push({
          _id: itemPedido.produto._id,
          qtd: itemPedido.quantidade,
        });
      } else {
        itemFind.qtd += itemPedido.quantidade;
      }
    }
    for (let itemLista of listaItensAgrupados) {
      await saldoReservaModel.update(
        this.state.db,
        itemLista._id,
        pedido._id,
        itemLista.qtd
      );
    }
  }

  async buscaDadosCliente(id) {
    let cliente = await clienteModel.findById(this.state.db, id);
    return cliente;
  }

  promiseOptions(inputValue) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        if (inputValue === "") {
          let clientes = await clienteModel.findAll(this.state.db);
          clientes = this.transformDataComboBoxCliente(clientes);
          this.setState({ clientes });

          resolve(clientes);
        } else {
          let aux = inputValue.substr(0, 1);
          let len = 2;
          if (aux == "&" || aux == "%") len = 3;
          if (inputValue.length >= len) {
            let clientes = await clienteModel.findAllByDesc(
              this.state.db,
              inputValue
            );

            clientes = this.transformDataComboBoxCliente(clientes);
            this.setState({ clientes });
            resolve(clientes);
          } else {
            resolve([]);
          }
        }
      }, 100);
    });
  }

  abrirPaginaInfoPedido() {
    if (this.state.pedido.cliente === null) {
      return false;
    }

    localStorage.setItem("pedido", JSON.stringify(this.state.pedido));

    if (this.state.actionPage === "CADASTRAR") {
      this.props.history.push(`/pedidos-novo-info`);
    } else if (this.state.actionPage === "EDITAR") {
      this.props.history.push(`/pedidos-editar-info`);
    }
  }

  calcularValorDesconto(valor, porcentagemDesconto) {
    valor = parseFloat(valor.toFixed(2));
    return valor - valor * (porcentagemDesconto / 100);
  }

  abrirPaginaCarrinho() {
    localStorage.setItem("pedido", JSON.stringify(this.state.pedido));
    this.props.history.push("/carrinho");

    // if (this.state.pedido.itens.length > 0) {
    //   this.props.history.push("/carrinho");
    // } else {
    //   this.props.history.push("/pedidos/novo");
    // }
  }

  promiseOptionsDesconto(inputValue) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        if (inputValue === "") {
          let descontos = await descontoModel.findAll(this.state.db);

          descontos = descontos.map((desconto) => {
            desconto.label = desconto.desc;
            desconto.value = desconto.desc;
            return desconto;
          });
          this.setState({ descontos });

          resolve(descontos);
        } else {
          if (inputValue.length >= 3) {
            let descontos = await descontoModel.findAllByDesc(
              this.state.db,
              inputValue
            );

            descontos = descontos.map((desconto) => {
              desconto.label = desconto.desc;
              desconto.value = desconto.desc;
              return desconto;
            });
            this.setState({ descontos });
            resolve(descontos);
          } else {
            resolve([]);
          }
        }
      }, 100);
    });
  }

  removeDesconto(itemPedido) {
    itemPedido.produto.preco.precoUnitComImpostosFinal =
      itemPedido.produto.preco.precoUnitComImpostos;

    if (itemPedido.produto.preco.pAcrescimo > 0) {
      let valor2 = parseFloat(
        (
          (itemPedido.produto.preco.pAcrescimo *
            itemPedido.produto.preco.precoUnitComImpostos) /
          100
        ).toFixed(2)
      );
      itemPedido.produto.preco.precoUnitComImpostosFinal = parseFloat(
        (itemPedido.produto.preco.precoUnitComImpostos + valor2).toFixed(2)
      );
    }

    if (itemPedido.produto.preco.pDesconto > 0) {
      let valor = parseFloat(
        (
          (itemPedido.produto.preco.pDesconto *
            itemPedido.produto.preco.precoUnitComImpostos) /
          100
        ).toFixed(2)
      );

      itemPedido.produto.preco.precoUnitComImpostosFinal = parseFloat(
        (itemPedido.produto.preco.precoUnitComImpostos - valor).toFixed(2)
      );
    }

    itemPedido.produto.preco.precoTotalComImpostosFinal = parseFloat(
      itemPedido.quantidade *
        itemPedido.produto.preco.precoUnitComImpostosFinal.toFixed(2)
    );

    return itemPedido;
  }

  async gerarPedido() {
    await this.editarOrcamento('gerarPedido');
    let orcamentoAtual = await orcamentoModel.findById(
      this.state.db,
      this.state.idPedido
    );

    if (!orcamentoAtual.expiracao.permitidoAlteracao) {
      // PEDIDO EXPIRADO OU INATIVO
      return this.props.history.push("/home");
    }

    let novoPedido = JSON.parse(JSON.stringify(orcamentoAtual));
    novoPedido.type = "pedido";
    novoPedido.sinc = false;
    novoPedido.sincIntegracao = false;
    novoPedido.dtIntegracao = null;
    novoPedido.status = "A";
    novoPedido.data = new Date();

    delete novoPedido._rev;
    novoPedido._id = `${this.state.usuario.codWeb}-${new Date().getTime()}`;

    let novoCodigo = await sequenciaPedidoModel.get(this.state.db);
    await sequenciaPedidoModel.increment(this.state.db);

    novoPedido.codigo = `${this.state.usuario.codWeb}/${novoCodigo
      .toString()
      .padStart(4, 0)}`;

    novoPedido.vendedor.enviaCopiaPedido = false;

    await this.state.db.put(novoPedido);

    let orcamentoBkp = JSON.parse(JSON.stringify(orcamentoAtual));

    let orcamentoAnt = {
      _id: orcamentoAtual._id,
      _rev: orcamentoAtual._rev,
      idPedido: novoPedido._id,
      sinc: orcamentoAtual.sinc,
      vendedor: orcamentoAtual.vendedor,
      valorTotal: orcamentoAtual.valorTotal,
      data: orcamentoAtual.data,
      status: "C",
      type: "orcamento",
      dtGeracaoPedido: new Date(),
      doc: {
        ...orcamentoBkp,
      },
    };

    await this.state.db.put(orcamentoAnt);

    this.notificar("success", "Pedido gerado com sucesso!");

    let pedidoFormatado = this.formatarAgendamentoImpressao(novoPedido);
    this.gerarImpressao(pedidoFormatado);

    await axios
      .post(`${this.props.getBaseUrlApi()}/meta-usuario/atualizar`, {
        idUsuario: this.state.usuario._id,
        idVendedor: novoPedido.vendedor._id,
      })
      .then(async (response) => {})
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          // this.notificar("warning", error.response.data.erro);
        }
      });

    setTimeout(() => {
      window.location.href = "/pedidos";
    }, 1500);
  }

  toggle() {
    this.setState({ modal: !this.state.modal });
  }

  abrirPaginaEditarContatos() {
    localStorage.setItem("urlAnterior", this.props.history.location.pathname);
    localStorage.setItem("pedido", JSON.stringify(this.state.pedido));
    this.props.history.push(`/contatos/editar?id=${this.state.idCliente}`);
  }

  async atualizaSaldoOver(vendedor, itens, idPedido) {
    let descontoTotal = 0;
    let acrescimoTotal = 0;

    for (let item of itens) {
      if (item.produto.preco.valorAcrescimo > 0) {
        acrescimoTotal +=
          item.produto.preco.valorAcrescimo * parseFloat(item.quantidade);
      }

      if (item.produto.preco.valorDesconto > 0) {
        descontoTotal +=
          item.produto.preco.valorDesconto * parseFloat(item.quantidade);
      }
    }

    let novoSaldo = vendedor.vlOver - descontoTotal;
    novoSaldo += acrescimoTotal;

    let diferencaSaldoOver = Math.abs(vendedor.vlOver - novoSaldo);
    diferencaSaldoOver = formatarCasaDecimal(diferencaSaldoOver);

    if (novoSaldo !== vendedor.vlOver) {
      await saldoOverModel.update(
        this.state.db,
        idPedido,
        diferencaSaldoOver,
        novoSaldo > vendedor.vlOver ? "A" : "D",
        vendedor.idIntegracao
      );
    }
  }

  abrirPaginasEtapa(pagina) {
    if (pagina !== "pedido" && this.state.pedido.cliente === null) {
      this.notificar("warning", "Selecione o cliente para continuar!");
      return false;
    }

    if (this.state.actionPage === "CADASTRAR") {
      localStorage.setItem("pedido", JSON.stringify(this.state.pedido));
    } else if (this.state.actionPage === "EDITAR") {
      localStorage.setItem("orcamento", JSON.stringify(this.state.pedido));
    }

    let url = "";

    if (pagina === "pedido") {
      url = "/pedidos-novo";
    } else if (pagina === "pedidoInfo") {
      url = "/pedidos-novo-info";
    } else if (pagina === "carrinho") {
      url = "/carrinho";
    } else if (pagina === "revisao") {
      url = "/pedidos-revisao";
    }
    if (this.state.actionPage === "EDITAR") {
      url = url + `?id=${this.state.idPedido}`;
    }
    this.props.history.push(url);
  }

  async gerarImpressao(pedido) {
    let parametros = { ...pedido };

    await axios
      .post(`${this.props.getBaseUrlImpressao()}/impressao-pedido-orcamento`, {
        parametros,
      })
      .then(async (response) => {
        localStorage.setItem("html", response.data.html);
        localStorage.setItem(
          "tituloPagina",
          `Comprovante do ${
            pedido.tipoDoc === "pedido" ? "Pedido" : "Orçamento"
          } ${pedido.codigo}`
        );
        window.open("/impressao", "_blank");
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          // this.notificar("warning", error.response.data.erro);
        }
      });
  }

  formatarAgendamentoImpressao(novoPedido) {
    let pedido = JSON.parse(JSON.stringify(novoPedido));

    let pedidoFormatado = {
      codigo: "#" + pedido.codigo,
      tipoPedido: pedido.tipoPedido.desc,
      dataEmissao: moment(pedido.data).format("DD/MM/YYYY"),
      cliente: pedido.cliente.cnpjCpf + " - " + pedido.cliente.desc,
      endereco: {
        rua: pedido.enderecoEntrega.endereco,
        numero: pedido.enderecoEntrega.numero,
        bairro: pedido.enderecoEntrega.bairro,
        cidade: pedido.enderecoEntrega.cidade,
        uf: pedido.enderecoEntrega.estado,
        cep: pedido.enderecoEntrega.cep,
      },
      enderecoEntrega: {
        rua: pedido.enderecoEntrega.endereco,
        numero: pedido.enderecoEntrega.numero,
        bairro: pedido.enderecoEntrega.bairro,
        cidade: pedido.enderecoEntrega.cidade,
        uf: pedido.enderecoEntrega.estado,
        cep: pedido.enderecoEntrega.cep,
      },
      contato: pedido.contato.desc,
      celular: pedido.contato.cel,
      email: pedido.contato.email,
      itens: [],
      total: "",
      condicaoPagamento: pedido.condPagto.desc,
      formaPagamento: pedido.formaPagto.desc,
      transportadora: pedido.transportadora.desc,
      previsaoEntrega: moment(pedido.previsaoEntrega).format("DD/MM/YYYY"),
      ordemCompra: pedido.ordemCompra,
      vendedor: {
        desc: pedido.vendedor.desc,
        celular: pedido.vendedor.cel,
        email: pedido.vendedor.email,
      },
      empresa: {
        desc: pedido.empresa.razaoSocial,
        cnpjCpf: pedido.empresa.cnpjCpf,
        ie: pedido.empresa.ie,
      },
      tipoDoc: pedido.type,
      observacao: pedido.observacao,
    };

    let valorTotal = 0;

    for (let item of pedido.itens) {
      pedidoFormatado.itens.push({
        codigo: item.produto.cod,
        un: item.produto.unid,
        desc: item.produto.desc,
        qtd: item.quantidade,
        valorUnitario: `R$ ${formatarReal(
          item.produto.preco.precoUnitComImpostosFinal
        )}`,
        desconto: `R$ ${formatarReal(item.produto.preco.valorDesconto)}`,
        totalItem: `R$ ${formatarReal(
          item.produto.preco.precoTotalComImpostosFinal
        )}`,
        obs:
          item.produto.obsItemNovo === undefined
            ? ""
            : item.produto.obsItemNovo,
      });
      valorTotal = valorTotal + item.produto.preco.precoTotalComImpostosFinal;
    }
    pedidoFormatado.total = `R$ ${formatarReal(valorTotal)}`;
    return pedidoFormatado;
  }

  async verificaAutenticacao() {
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/verifica-autenticacao-pedidos`,
        {
          idUsuario: localStorage.getItem("idUsuario"),
          hash: localStorage.getItem("hash"),
        },
        this.props.parameters()
      )
      .then((response) => {
        if (!response.data.valido) {
          this.props.logout();
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push("/home");
          }
        }
      });
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar
            title={`Revisão do ${
              this.state.actionPage === "CADASTRAR" ? "Pedido" : "Orçamento"
            }`}
          />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"novoPedido"} />
            <div className="main-panel">
              <div className="content-wrapper">
                <div>
                  <ul
                    id="alterUl"
                    className="nav nav-tabs justify-content-center process-model more-icon-preocess"
                    role="tablist"
                  >
                    <li
                      id="li-cliente"
                      role="presentation"
                      className="visited"
                      onClick={() => {
                        this.abrirPaginasEtapa("pedido");
                      }}
                    >
                      <a aria-controls="discover" role="tab" data-toggle="tab">
                        <i className="fa fa-plus" aria-hidden="true"></i>
                        <p>Pedido</p>
                      </a>
                    </li>

                    <li
                      id="li-info"
                      role="presentation"
                      onClick={() => {
                        this.abrirPaginasEtapa("pedidoInfo");
                      }}
                      className="visited"
                    >
                      <a aria-controls="content" role="tab" data-toggle="tab">
                        <i className="fa fa-newspaper-o" aria-hidden="true"></i>
                        <p>Info adicionais</p>
                      </a>
                    </li>
                    <li
                      id="li-info"
                      role="presentation"
                      onClick={() => {
                        this.abrirPaginasEtapa("carrinho");
                      }}
                      className="visited"
                    >
                      <a aria-controls="content" role="tab" data-toggle="tab">
                        <i
                          className="fa fa-shopping-cart"
                          aria-hidden="true"
                        ></i>
                        <p>Itens</p>
                      </a>
                    </li>
                    <li id="li-info" role="presentation" className="active">
                      <a aria-controls="content" role="tab" data-toggle="tab">
                        <i className="fa fa-edit" aria-hidden="true"></i>
                        <p>Revisão</p>
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="row">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        <div className="tab-content py-0 px-0">
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div
                                style={{
                                  padding: "15px",
                                  float: "left",
                                  width: "100%",
                                }}
                              >
                                <div
                                  className="row font-size-13"
                                  style={{ padding: "10px" }}
                                >
                                  <div className="col-md-2 pd-pedido">
                                    <div className="form-group">
                                      <label className="font-size-14">
                                        Código
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control font-size-14"
                                        value={`#${this.state.codigoPedido}`}
                                        disabled={true}
                                        style={{
                                          color: "#5f9f1a",
                                          fontWeight: "bold",
                                        }}
                                      />
                                    </div>
                                  </div>
                                  {/* <div className="col-md-2 pd-pedido">
                                    <div className="form-group">
                                      <label className="font-size-14">
                                        Tipo de Pedido
                                      </label>
                                      <Select
                                        options={this.state.tiposPedido}
                                        value={this.state.pedido.tipoPedido}
                                        onChange={(item) =>
                                          this.handleChangeSelect(
                                            item,
                                            "tipoPedido"
                                          )
                                        }
                                        className={`font-size-14 ${
                                          this.state.errors.tipoPedido
                                            ? "select-error"
                                            : ""
                                        }`}
                                        placeholder="Selecione"
                                        isDisabled={
                                          this.state.pedido.status === "I"
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  </div> */}
                                  <div className="col-md-3 pd-pedido">
                                    <div className="form-group">
                                      <label
                                        className="font-size-14"
                                        style={{ marginRight: "3px" }}
                                      >
                                        Cliente
                                      </label>{" "}
                                      {this.state.exibirLegendaCliente && (
                                        <React.Fragment>
                                          <span
                                            style={{
                                              position: "relative",
                                              cursor: "pointer",
                                            }}
                                            id="legendaCliente"
                                          >
                                            <i
                                              className="fa fa-circle"
                                              style={{
                                                color: this.state.corLegenda,
                                              }}
                                            ></i>
                                            <span className="icone-info">
                                              i
                                            </span>
                                          </span>

                                          <UncontrolledTooltip
                                            placement="right"
                                            target="legendaCliente"
                                          >
                                            {this.state.textoLegenda}
                                          </UncontrolledTooltip>
                                        </React.Fragment>
                                      )}
                                      <AsyncSelect
                                        cacheOptions
                                        defaultOptions
                                        loadOptions={this.promiseOptions}
                                        value={this.state.pedido.cliente}
                                        onChange={(item) =>
                                          this.handleChangeSelect(
                                            item,
                                            "cliente",
                                            true
                                          )
                                        }
                                        className={`font-size-14 ${
                                          this.state.errors.cliente
                                            ? "select-error"
                                            : ""
                                        }`}
                                        placeholder="Selecione"
                                        isDisabled={true}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-2 pd-pedido">
                                    <div className="form-group">
                                      <label className="font-size-14">
                                        Condição de Pagto
                                      </label>
                                      <Select
                                        options={this.state.condicoesPagamento}
                                        value={this.state.pedido.condPagto}
                                        onChange={(item) =>
                                          this.handleChangeSelect(
                                            item,
                                            "condPagto"
                                          )
                                        }
                                        className={`font-size-14 ${
                                          this.state.errors.condPagto
                                            ? "select-error"
                                            : ""
                                        }`}
                                        placeholder="Selecione"
                                        isDisabled={true}
                                      />
                                    </div>
                                  </div>
                                  {/* <div
                                    className={`col-md-2 pd-pedido porcentagem-desconto font-13`}
                                  >
                                    <div className="form-group">
                                      <label className="font-size-14">
                                        Desconto
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control text-right font-size-14"
                                        disabled={true}
                                        value={
                                          this.state.pedido.condPagto !== null
                                            ? `${this.state.pedido.condPagto.pDesc
                                                .toFixed(2)
                                                .replace(".", ",")}%`
                                            : "0,00%"
                                        }
                                      />
                                    </div>
                                  </div> */}
                                  <div className="col-md-2 pd-pedido">
                                    <div className="form-group">
                                      <label className="font-size-14">
                                        Forma de pagamento
                                      </label>
                                      <Select
                                        options={this.state.formasPagamento}
                                        value={this.state.pedido.formaPagto}
                                        onChange={(item) =>
                                          this.handleChangeSelect(
                                            item,
                                            "formaPagto"
                                          )
                                        }
                                        className={`font-size-14 ${
                                          this.state.errors.formaPagto
                                            ? "select-error"
                                            : ""
                                        }`}
                                        placeholder="Selecione"
                                        isDisabled={true}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-2 pd-pedido">
                                    <div className="form-group">
                                      <label className="font-size-14">
                                        Transportadora
                                      </label>
                                      <Select
                                        options={this.state.transportadoras}
                                        value={this.state.pedido.transportadora}
                                        onChange={(item) =>
                                          this.handleChangeSelect(
                                            item,
                                            "transportadora"
                                          )
                                        }
                                        className={`font-size-14 ${
                                          this.state.errors.transportadora
                                            ? "select-error"
                                            : ""
                                        }`}
                                        placeholder="Selecione"
                                        isDisabled={true}
                                      />
                                    </div>
                                  </div>
                                  {this.state.parametros !== null &&
                                    this.state.parametros.tipoDesconto ===
                                      "progressivo" && (
                                      <React.Fragment>
                                        <div className="col-md-2 pd-pedido">
                                          <div className="form-group">
                                            <label className="font-size-14">
                                              Desconto progressivo
                                            </label>
                                            <AsyncSelect
                                              cacheOptions
                                              defaultOptions
                                              loadOptions={
                                                this.promiseOptionsDesconto
                                              }
                                              value={this.state.pedido.desconto}
                                              onChange={(item) =>
                                                this.handleChangeSelect(
                                                  item,
                                                  "desconto"
                                                )
                                              }
                                              placeholder="Selecione"
                                              className="font-size-14"
                                              isDisabled={true}
                                            />
                                            {this.state.pedido.desconto !==
                                              null && (
                                              <small
                                                style={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                  this.setState(
                                                    {
                                                      pedido: {
                                                        ...this.state.pedido,
                                                        desconto: null,
                                                      },
                                                    },
                                                    () => {
                                                      this.calcularTotalPedido();
                                                    }
                                                  );
                                                }}
                                              >
                                                Remover desconto
                                              </small>
                                            )}
                                          </div>
                                        </div>
                                      </React.Fragment>
                                    )}

                                  <div className="col-md-4 pd-pedido">
                                    <div className="form-group">
                                      <label className="font-size-14">
                                        Endereço de entrega
                                      </label>
                                      <span
                                        style={{
                                          fontSize: "22px",
                                          paddingLeft: "5px",
                                          paddingTop: "24px",
                                          cursor: "pointer",
                                          color: "#888",
                                        }}
                                        // onClick={
                                        //   this.abrirPaginaAdicionarEndereco
                                        // }
                                      ></span>

                                      <Select
                                        options={this.state.enderecos}
                                        value={this.state.pedido.endereco}
                                        onChange={(item) =>
                                          this.handleChangeSelect(
                                            item,
                                            "endereco"
                                          )
                                        }
                                        placeholder="Selecione"
                                        isDisabled={true}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-2 pd-pedido">
                                    <div className="form-group">
                                      <label className="font-size-14">
                                        Total do pedido
                                      </label>

                                      <input
                                        type="text"
                                        className="form-control font-size-14 text-right"
                                        value={`R$ ${formatarReal(
                                          this.state.totalPedido
                                        )}`}
                                        disabled={true}
                                        style={{
                                          color: "#7dd421",
                                          fontWeight: "bold",
                                        }}
                                      />
                                    </div>
                                  </div>
                                  {/* <div className="col-md-2 pd-pedido">
                                    <div className="form-group">
                                      <label className="font-size-14">
                                        Total da comissão
                                      </label>

                                      <input
                                        type="text"
                                        className="form-control font-size-14 text-right"
                                        value={`R$ ${formatarReal(
                                          this.state.comissao
                                        )}`}
                                        disabled={true}
                                        style={{
                                          color: "#7dd421",
                                          fontWeight: "bold",
                                        }}
                                      />
                                    </div>
                                  </div> */}

                                  <div
                                    className="row float-left w-100"
                                    style={{ padding: "15px" }}
                                  >
                                    <div className="table-responsive">
                                      <table className="table table-striped">
                                        <thead className="thead-dark">
                                          <tr>
                                            <th scope="col">Item</th>
                                            {/* <th
                                              scope="col"
                                              className="text-right"
                                            >
                                              Estoque
                                            </th> */}
                                            <th
                                              scope="col"
                                              className="text-right"
                                            >
                                              Qtd
                                            </th>

                                            <th
                                              scope="col"
                                              className="text-right"
                                            >
                                              Valor
                                            </th>
                                            <th
                                              scope="col"
                                              className="text-right"
                                            >
                                              Valor Total
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.state.pedido !== null &&
                                            this.state.pedido.itens.map(
                                              (item, index) => (
                                                <tr>
                                                  <td>
                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      ({item.produto.cod}) -{" "}
                                                      {item.produto.desc}
                                                    </span>
                                                    <div
                                                      style={{
                                                        marginTop: "3px",
                                                      }}
                                                    >
                                                      Embalagem:{" "}
                                                      {
                                                        item.produto.preco
                                                          .embPadrao
                                                      }{" "}
                                                      {item.produto.unid}
                                                    </div>
                                                  </td>
                                                  {/* <td className="text-right">
                                                    1 {item.produto.unid}
                                                  </td> */}
                                                  <td className="text-right">
                                                    {item.quantidade}{" "}
                                                    {item.produto.unid}
                                                  </td>
                                                  <td className="text-right">
                                                    R${" "}
                                                    {formatarRealCarrinho(
                                                      item.produto.preco
                                                        .precoUnitComImpostosFinal
                                                    )}
                                                  </td>
                                                  <td className="text-right">
                                                    R${" "}
                                                    {formatarRealCarrinho(
                                                      item.valorTotalItem
                                                    )}
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>

                                  <div className="d-flex float-left w-100 pd-pedido">
                                    {this.state.actionPage === "CADASTRAR" && (
                                      <React.Fragment>
                                        <div style={{ margin: "5px" }}>
                                          <button
                                            className="btn btn-success btn-app-pedidos"
                                            onClick={() =>
                                              this.cadastrarPedido("orcamento")
                                            }
                                          >
                                            Gerar orçamento
                                          </button>
                                        </div>
                                        <div style={{ margin: "5px" }}>
                                          <button
                                            className="btn btn-success btn-app-pedidos-verde"
                                            onClick={() => {
                                              this.cadastrarPedido("pedido");
                                            }}
                                          >
                                            Fechar pedido
                                          </button>
                                        </div>
                                      </React.Fragment>
                                    )}

                                    {this.state.actionPage === "EDITAR" && (
                                      <React.Fragment>
                                        <div style={{ margin: "5px" }}>
                                          <button
                                            className="btn btn-success btn-app-pedidos"
                                            onClick={() => {
                                              this.editarOrcamento(
                                                "editarOrcamento"
                                              );
                                            }}
                                          >
                                            Editar Orçamento
                                          </button>
                                        </div>
                                        <div style={{ margin: "5px" }}>
                                          <button
                                            className="btn btn-success btn-app-pedidos-verde"
                                            onClick={() => {
                                              this.gerarPedido();
                                            }}
                                          >
                                            Gerar Pedido
                                          </button>
                                        </div>
                                      </React.Fragment>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
